import { Form, Icon, Input, Button, Layout, Switch, Checkbox } from "antd";
import React from "react";
import "./NormalLoginForm.css";
import withSharedStateConsumer from "../../contexts/shared-state/withSharedStateConsumer";
import { withRouter } from "react-router-dom";
import { showErrorToast } from "../general/ToastHelper";
import vodafone from "../../resource/vodafoneIVR.png";
import { Constants } from "../../data/constants";
import { AuthenticationService } from "../../services/logIn/AuthenticationService";
import { handleError } from "../../utils/ErrorHandlers";

import LanguageSwitcher from "../LanguageSwitcher";
import { Translation, withTranslation } from "react-i18next";
import i18next from "i18next";
import ChangePassword from "../user/ChangePassword";
import ForgotPassword from "../user/ForgotPassword";
import MFA from "./MFA";
const { Header, Footer, Content } = Layout;
class NormalLoginForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      showChangePassword: false,
      showForgotPassword: false,
      sessionToken: "",
      userEmail: "",
      responseData: [],
      flag:true,
      userId:"",
      userNumber:"",
      langKey:"en"
    };

    this.constants = new Constants();
    this.logInService = new AuthenticationService();
  }

  replaceNull(someObj, replaceValue = "") {
    const replacer = (key, value) =>
      String(value) === "null" || String(value) === "undefined"
        ? replaceValue
        : value;

    return JSON.parse(JSON.stringify(someObj, replacer));
  }

  switchLanguage(key) {
    i18next.changeLanguage(key);
    this.props.context.updateLangAndDir(key, key === "en" ? "ltr" : "rtl");
    document.querySelector("html").dir = key === "en" ? "ltr" : "rtl";
    sessionStorage.setItem("dir", key === "en" ? "ltr" : "rtl");
    this.setState({langKey:key})

  }

  handleSubmit = async (e) => {
    e.preventDefault();
    let { updateUserAndSession } = this.props.context;

    let { history } = this.props;

    this.props.form.validateFields(async (err, values) => {
      
      try {
        if(err){
          // handleError({message:"xxxxxxxxxxxxxxxxxxx"});
          return;
        }
        this.setState({ loading: true });
        let logInResponse = await this.logInService.logIn(
          values["userEmail"],
          values["password"]
        );
        this.setState({ loading: false });

        this.setState({userId:logInResponse[0].ivrCustomEntityObject.userId})
        this.setState({userNumber:logInResponse[0].ivrCustomEntityObject.userNumber})
        if(logInResponse[0].ivrCustomEntityObject.userType=="SUPER" || logInResponse[0].ivrCustomEntityObject.userType=="LI" || logInResponse[0].ivrCustomEntityObject.userType=="CARE" || logInResponse[0].ivrCustomEntityObject.userType=="ADMIN" || logInResponse[0].ivrCustomEntityObject.userType=="AGENT"){
          this.switchLanguage(
            logInResponse[0].ivrCustomEntityObject.language
              ? logInResponse[0].ivrCustomEntityObject.language
              : i18next.language
          );
          this.setState({
            sessionToken: logInResponse[1],
            userEmail: logInResponse[0].ivrCustomEntityObject.userEmail,
            responseData: logInResponse[0].ivrCustomEntityObject,
          });
      
          if (
            logInResponse[0]["statusCode"] === this.constants.successCode &&
            logInResponse[0].ivrCustomEntityObject.userAccountStatus === "ACT" &&
            logInResponse[0].ivrCustomEntityObject.resetPasswordFlag == false
          ) {
            updateUserAndSession(
              logInResponse[1],
              logInResponse[0].ivrCustomEntityObject
            );
          }
          if (
            logInResponse[0]["statusCode"] ===
            this.constants.response_success_auth_failed
          ) {
            this.setState({ loading: false });
            throw new Error(i18next.t("User authentication failed"));
          }
      
          if (
            logInResponse[0].ivrCustomEntityObject.resetPasswordFlag &&
            logInResponse[0].ivrCustomEntityObject.userAccountStatus === "ACT"
          ) {
            this.setState({
              showChangePassword: true,
            });
          } else if (
            logInResponse[0].ivrCustomEntityObject.userType === "SUPER" ||
            logInResponse[0].ivrCustomEntityObject.userType === "CARE"
          ) {
            if (
              logInResponse[0].ivrCustomEntityObject.userAccountStatus === "INT"
            ) {
              this.setState({
                showChangePassword: true,
              });
            } else {
              history.push("/home/accounts");
            }
          }
          else if (
            logInResponse[0].ivrCustomEntityObject.userType === "LI" 
          ) {
            if (
              logInResponse[0].ivrCustomEntityObject.userAccountStatus === "INT"
            ) {
              this.setState({
                showChangePassword: true,
              });
            } else {
              history.push("/home/liveCalls");
            }
          } else if (
            logInResponse[0].ivrCustomEntityObject.userAccountStatus === "ACT"
          ) {
            history.push("/home/dashboard");
          } else if (
            logInResponse[0].ivrCustomEntityObject.userAccountStatus === "INT"
          ) {
            this.setState({
              showChangePassword: true,
            });
          }
        }else{
          this.setState({flag:false})

        }
 
      } catch (e) {
        this.setState({ loading: false });
        handleError({message:i18next.t(e.message)});
      }
    });
  };

  verifyOTP= async(code)=>{
    if(code==0){
      return
    }
    if(code==null){
      this.setState({flag:true})
      return
    }
    let { updateUserAndSession } = this.props.context;

    let { history } = this.props;
    try{
     let logInResponse = await this.logInService.verifyMFA(this.state.userId,code);

    this.switchLanguage(
      logInResponse[0].ivrCustomEntityObject.language
        ? logInResponse[0].ivrCustomEntityObject.language
        : i18next.language
    );
    this.setState({
      sessionToken: logInResponse[1],
      userEmail: logInResponse[0].ivrCustomEntityObject.userEmail,
      responseData: logInResponse[0].ivrCustomEntityObject,
    });

    if (
      logInResponse[0]["statusCode"] === this.constants.successCode &&
      logInResponse[0].ivrCustomEntityObject.userAccountStatus === "ACT" &&
      logInResponse[0].ivrCustomEntityObject.resetPasswordFlag == false
    ) {
      updateUserAndSession(
        logInResponse[1],
        logInResponse[0].ivrCustomEntityObject
      );
    }
    if (
      logInResponse[0]["statusCode"] ===
      this.constants.response_success_auth_failed
    ) {
      this.setState({ loading: false });
      throw new Error(i18next.t("User authentication failed"));
    }

    if (
      logInResponse[0].ivrCustomEntityObject.resetPasswordFlag &&
      logInResponse[0].ivrCustomEntityObject.userAccountStatus === "ACT"
    ) {
      this.setState({
        showChangePassword: true,
      });
    } else if (
      logInResponse[0].ivrCustomEntityObject.userType === "SUPER" ||
      logInResponse[0].ivrCustomEntityObject.userType === "CARE"
    ) {
      if (
        logInResponse[0].ivrCustomEntityObject.userAccountStatus === "INT"
      ) {
        this.setState({
          showChangePassword: true,
        });
      } else {
        history.push("/home/accounts");
      }
    } else if (
      logInResponse[0].ivrCustomEntityObject.userAccountStatus === "ACT"
    ) {
      history.push("/home/dashboard");
    } else if (
      logInResponse[0].ivrCustomEntityObject.userAccountStatus === "INT"
    ) {
      this.setState({
        showChangePassword: true,
      });
    }
  }catch (e) {
    this.setState({ loading: false });
    handleError(e);
  }
  }

  componentDidMount() {
    this.props.context.updateLangAndDir(
      this.props.i18n.language,
      this.props.i18n.language === "en" ? "ltr" : "rtl"
    );
  }

  render() {
    // <Content className="btn-switch">
    const { getFieldDecorator } = this.props.form;
    return (
      <Translation>
        {(t) => (
          <div className="login-wrapper">
            {this.state.flag ? <Form className="login-form" onSubmit={this.handleSubmit}>
              <LanguageSwitcher />
              <Form.Item className="login-form-item">
                <img src={vodafone} className="login-img" />
              </Form.Item>

              {this.state.showChangePassword && (
                <ChangePassword
                  changeForActivation={true}
                  sessionId={this.state.sessionToken}
                  userEmail={this.state.userEmail}
                  responseData={this.state.responseData}
                />
              )}
              {!this.state.showForgotPassword &&
                !this.state.showChangePassword && (
                  <div>
                    <Form.Item>
                      {getFieldDecorator("userEmail", {
                        rules: [
                          {
                            required: true,
                            message: t(
                              "Please enter your email or mobile number"
                            ),
                          },
                        ],
                      })(
                        <Input
                          prefix={<Icon type="user" className="input-icon" />}
                          placeholder={t("Email or mobile number")}
                        />
                      )}
                    </Form.Item>
                    <Form.Item>
                      {getFieldDecorator("password", {
                        rules: [
                          {
                            required: true,
                            message: t("Please enter your Password!"),
                          },
                        ],
                      })(
                        <Input.Password
                          prefix={<Icon type="lock" className="input-icon" />}
                          type="password"
                          visibilityToggle
                          placeholder={t("Password")}
                        />
                      )}
                    </Form.Item>

                    <Form.Item>
                      <a
                        className="login-form-forgot"
                        href="#"
                        onClick={(e) => {
                          e.preventDefault();
                          this.setState({ showForgotPassword: true });
                        }}
                      >
                        {t("Forgot password?")}
                      </a>
                      <Button
                        type="primary"
                        htmlType="submit"
                        className="login-form-button"
                        loading={this.state.loading}
                        onClick={this.handleSubmit}
                      >
                        {t("Login")}
                      </Button>
                    </Form.Item>
                  </div>
                )}
              {this.state.showForgotPassword && (
                <ForgotPassword
                  backToLogin={() => {
                    this.setState({
                      showChangePassword: false,
                      showForgotPassword: false,
                    });
                  }}
                />
              )}
            </Form> :
            <Form className="mfa-form"> <Form.Item className="login-form-item">
            <img src={vodafone} className="login-img" />
          </Form.Item>
          <MFA userNumber={this.state.userNumber} userId={this.state.userId} verifyMFA={async (code)=>{ await  this.verifyOTP(code)}} /> 
          </Form>}
          </div>
        )}
      </Translation>
    );
  }
}

export default Form.create()(
  withSharedStateConsumer(withRouter(withTranslation()(NormalLoginForm)))
);
